import { render, staticRenderFns } from "./Subsidiary.vue?vue&type=template&id=70c4f6e7&scoped=true"
import script from "./Subsidiary.vue?vue&type=script&lang=js"
export * from "./Subsidiary.vue?vue&type=script&lang=js"
import style0 from "./Subsidiary.vue?vue&type=style&index=0&id=70c4f6e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4f6e7",
  null
  
)

export default component.exports